
import { jwtDecode } from 'jwt-decode';
import moment from 'moment';
import { sha256 } from 'js-sha256';
import { user } from 'services';
class Helper {
  // Chek if the user is allowed to access the frontend
  startUserValidationTimer() {
    if (this._validationInterval) {
      clearTimeout(this._validationInterval);
    }
    this._validationInterval = setTimeout(() => {
      let token = user.getToken();
      if (token) {
        try {
          // fingerprint check to validate the token is from frontend
          token = jwtDecode(token);
          let tokenFingerprint = token.ffp;
          let fingerprint = localStorage.getItem('fingerprint');
          fingerprint = sha256(fingerprint + '');
          if (tokenFingerprint !== fingerprint) {
            user.setToken(null);
            user.setUser(null);
            window.location.href = "/login";
            return;
          }

          if (!token || !token.pwa) {
            user.setToken(null);
            user.setUser(null);
            window.location.href = "/login";
            return;
          };
          
          const now = moment();
          let dayOfWeek = now.isoWeekday();
          const year = now.year();
          const month = now.month() + 1;
          const dayOfMonth = now.date();
          let prevDayOfWeek = dayOfWeek === 1 ? 7 : dayOfWeek - 1;
          let nextDayOfWeek = dayOfWeek === 7 ? 1 : dayOfWeek + 1;
          let todayPwa = (token.pwa - dayOfWeek) / month;
          let prevPwa = (token.pwa - prevDayOfWeek) / month;
          let nextPwa = (token.pwa - nextDayOfWeek) / month;
          if (todayPwa % year !== 0 && prevPwa % year !== 0 && nextPwa % year !== 0) {
            if (dayOfMonth === 1) {
              const prevMonth = month === 1 ? 12 : month - 1;
              const prevYear = month === 1 ? year - 1 : year;
              todayPwa = (token.pwa - dayOfWeek) / prevMonth;
              nextPwa = (token.pwa - nextDayOfWeek) / prevMonth;
              prevPwa = (token.pwa - prevDayOfWeek) / prevMonth;
              if (todayPwa % prevYear !== 0 && nextPwa % prevYear !== 0 && prevPwa % prevYear !== 0) {
                user.setToken(null);
                user.setUser(null);
                window.location.href = "/login";
                return;
              }
            } else {
              user.setToken(null);
              user.setUser(null);
              window.location.href = "/login";
              return;
            }
          }
          
          if (user.getUser() && user.getUser().prevent_frontend_access){
            user.setToken(null);
            user.setUser(null);
            window.location.href = "/login";
            return;
          }
        } catch (e) {
          user.setToken(null);
          user.setUser(null);
          window.location.href = "/login";
          return;
        }
      }
    }, 1000);
  }

  stopUserValidationTimer() {
    if (this._validationInterval) {
      clearTimeout(this._validationInterval);
      this._validationInterval = null;
    }
  }

  /**
   * For TPS temporary parking types named like "5_tps_temporary_...",
   * return the numeric parking type id before "_tps_".
   */
  resolveTpsParkingTypeId (item, fallbackTypeId = null) {
    const typeId = fallbackTypeId != null ? fallbackTypeId : (item && item.type_id);
    const typeName = (item && item.type && item.type.name) || (item && item.type_name) || '';
    const isParking = (item && (item.type_type === 'parking' || item.type === 'parking'));

    if (!isParking || !typeName) {
      return typeId;
    }

    const match = String(typeName).match(/^(\d+)_tps_/i);
    if (match) {
      return Number(match[1]);
    }

    return typeId;
  }

  validateChanges (keys, current_state, old_state, db_state) {
    let keys_to_sync = [];
    let changed_keys = [];

    keys.forEach((key) => {
      if (old_state[key] != current_state[key]) {
        changed_keys.push(key);
      }
    });

    keys.forEach((key) => {      
      if (typeof db_state[key] === 'object') {
        if (JSON.stringify(db_state[key]) != JSON.stringify(old_state[key])) {
          keys_to_sync.push(key);
        }
      } else {
        if (db_state[key] != old_state[key]) {
          keys_to_sync.push(key);
        }
      }
    });

    let conflicted_keys = keys_to_sync.filter(key => changed_keys.includes(key));
    
    if (conflicted_keys.length) {
      return false;
    }

    keys_to_sync.forEach((key) => {
      current_state[key] = db_state[key];
    });
    
    return true;
  }
}

export default new Helper();
